var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mconarall"},[_c('Header',{attrs:{"header":_vm.header}}),_c('MyPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }